import React, { useState, useEffect } from 'react';
import validationAuth from '../../validationAuth';
import axios from 'axios';
import {
    Container, List, ListItem, ListItemText, ListItemSecondaryAction,
    Box, IconButton, ListItemIcon, Typography, FormControl, Select, MenuItem, InputLabel
} from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
//import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import * as common from '../../commons/common';
import { useNavigate } from 'react-router-dom';
import checkerListMenuIcon from '../../images/checker_list_menu_icon.png';
import rightArrowIcon from '../../images/right_arrow_icon.svg';

//점검목록 - 조회 tab (점검 완료한 리스트)
const RegisteredList = () => {
    const [items, setItems] = useState([]);
    const [facilityTypes, setFacilityTypes] = useState([]);
    const [selectedFacilityType, setSelectedFacilityType] = useState(0);
    const navigate = useNavigate();

    // 점검 목록 가져오기
    const fetchItems = async (facilityTypeId) => {
        const url = `${common.getApiUrl()}/checker`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                params: {
                    facilityTypeId: facilityTypeId || ''
                }
            });
            if (response.data && Array.isArray(response.data)) {
                const fetchedItems = response.data.map(item => ({
                    id: item.facilityId.toString(),
                    title: item.facilityNm,
                    description: `${item.facilityTypeNm || 'N/A'}`,
                    lastCheckTime: item.lastCheckTime
                }));

                // 저장된 순서 복원
                const savedOrder = JSON.parse(localStorage.getItem('checkListOrder') || '[]');
                let orderedItems = fetchedItems;

                if (savedOrder.length > 0) {
                    const orderedFromStorage = [];
                    const unorderedItems = [...fetchedItems];

                    savedOrder.forEach(savedId => {
                        const foundIndex = unorderedItems.findIndex(item => item.id === savedId);
                        if (foundIndex !== -1) {
                            orderedFromStorage.push(unorderedItems.splice(foundIndex, 1)[0]);
                        }
                    });

                    orderedItems = [...orderedFromStorage, ...unorderedItems];
                }

                setItems(orderedItems);
                localStorage.setItem('checkListItems', JSON.stringify(orderedItems));
            }
        } catch (error) {
            common.handleApiError(error);
        }
    };

    // 시설 유형 목록 가져오기
    const fetchFacilityTypes = async () => {
        const url = `${common.getApiUrl()}/checker/facilityType`;
        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            if (response.data && Array.isArray(response.data)) {
                const updatedFacilityTypes = [
                    {
                        facilityTypeId: 0,
                        facilityTypeNm: "전체"
                    },
                    ...response.data
                ];
                setFacilityTypes(updatedFacilityTypes);
            }
        } catch (error) {
            common.handleApiError(error);
        }
    };

    useEffect(() => {
        fetchItems();
        fetchFacilityTypes();
    }, []);

    // 드래그 앤 드롭 종료 처리
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        const newList = Array.from(items);
        const [removed] = newList.splice(result.source.index, 1);
        newList.splice(result.destination.index, 0, removed);

        setItems(newList);

        // 로컬스토리지에 순서와 아이템 정보 저장
        localStorage.setItem('checkListOrder', JSON.stringify(newList.map(item => item.id)));
        localStorage.setItem('checkListItems', JSON.stringify(newList));
    };

    const handleItemClick = (item) => {
        navigate(`/checker/registered-detail/${item.id}`, { state: { facilityId: item.id, facilityName: item.title } });
    };

    const handleSelectChange = (event) => {
        setSelectedFacilityType(event.target.value);
        fetchItems(event.target.value);
    };

    return (
        <Container
            maxWidth="false"
            sx={{
                width: '100%',
                mx: 'auto',
                pt: 2,
                backgroundColor: 'var(--main-white-color)',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <FormControl fullWidth sx={{  mb: 1, mt: 1, position: 'relative' }}>
                <Select
                    id="select"
                    value={String(selectedFacilityType) || ''}
                    onChange={handleSelectChange}
                    IconComponent={ExpandMoreIcon}
                    displayEmpty
                    sx={{
                        borderRadius: '22px',
                        cursor: 'pointer',
                        backgroundColor: 'white',
                        height: '45px',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#807C7C',
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '0 14px 0 20px',
                            height: '100%',
                        },
                        '& .MuiSelect-icon': {
                            right: '20px'
                        },
                    }}
                >
                    {facilityTypes.map((type) => (
                        <MenuItem key={type.facilityTypeId} value={String(type.facilityTypeId)}>
                            <Typography sx={{ marginLeft: '5px', color: '#807C7C' }}>{type.facilityTypeNm}</Typography>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Box sx={{ flexGrow: 1 }}>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable-list">
                        {(provided) => (
                            <List
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                sx={{
                                    width: '100%',
                                    paddingTop: 1,
                                    paddingBottom: 1,
                                    backgroundColor: 'transparent',
                                }}
                            >
                                {items.map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided, snapshot) => (
                                            <Box
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                sx={{
                                                    mb: 1.0,
                                                    backgroundColor: 'white',
                                                    borderRadius: '12px',
                                                    overflow: 'hidden',
                                                    opacity: snapshot.isDragging ? 0.8 : 1,
                                                    transform: snapshot.isDragging ? 'rotate(2deg)' : 'none',
                                                    transition: 'opacity 0.2s ease, transform 0.2s ease',
                                                }}
                                            >
                                                <ListItem
                                                    sx={{
                                                        display: 'flex',
                                                        width: '100%',
                                                        minHeight: '80px',
                                                        padding: '4px 10px 4px 10px',
                                                        boxShadow: 'none',
                                                        transition: "background-color 0.2s ease",
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <ListItemIcon
                                                        sx={{
                                                            minWidth: 'auto',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                        }}
                                                    >
                                                        <Box
                                                            {...provided.dragHandleProps}
                                                            sx={{
                                                                cursor: 'grab',
                                                                opacity: 0.7,
                                                                padding: '8px',
                                                                marginRight: '12px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                borderRadius: '4px',
                                                                '&:active': {
                                                                    cursor: 'grabbing',
                                                                },
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                                                }
                                                            }}
                                                        >
                                                            <img
                                                                src={checkerListMenuIcon}
                                                                alt="menu"
                                                                style={{
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    objectFit: 'contain',
                                                                    pointerEvents: 'none',
                                                                }}
                                                            />
                                                        </Box>
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={item.title}
                                                        secondary={
                                                            <Box sx={{
                                                                display: 'inline-block',
                                                                padding: '1px 3px',
                                                                marginTop: '8px',
                                                                border: '1px solid #ccc',
                                                                borderRadius: '4px',
                                                                fontSize: '0.7rem',
                                                                wordBreak: 'break-all',
                                                                whiteSpace: 'normal',
                                                                lineHeight: 'normal',
                                                                fontWeight: 400
                                                            }}>
                                                                {item.description}
                                                            </Box>
                                                        }
                                                        primaryTypographyProps={{
                                                            fontSize: '1.2rem',
                                                            fontWeight: 'bold',
                                                            lineHeight: 1.1,
                                                            maxWidth: '80%'
                                                        }}
                                                    />
                                                    <ListItemSecondaryAction sx={{ right: 8 }}>
                                                        <IconButton
                                                            onClick={() => handleItemClick(item)}
                                                            sx={{
                                                                padding: '20px',
                                                                marginLeft: '-24px',
                                                                height: '100%',
                                                                borderRadius: '4px',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                                                }
                                                            }}
                                                        >
                                                            <img
                                                                src={rightArrowIcon}
                                                                alt="right arrow"
                                                                style={{
                                                                    width: '26px',
                                                                    height: '26px',
                                                                    objectFit: 'contain',
                                                                }}
                                                            />
                                                        </IconButton>
                                                        {/*<IconButton*/}
                                                        {/*    onClick={() => handleItemClick(item)}*/}
                                                        {/*    sx={{*/}
                                                        {/*        padding: '20px',          // 패딩 증가*/}
                                                        {/*        marginLeft: '-24px',      // 왼쪽으로 더 확장*/}
                                                        {/*        height: '100%',           // 높이를 100%로*/}
                                                        {/*        borderRadius: '4px',      // 선택적: 클릭 영역 시각화를 위한 border-radius*/}
                                                        {/*        '& svg': {*/}
                                                        {/*            fontSize: '1.2rem',*/}
                                                        {/*            color: '#666'*/}
                                                        {/*        },*/}
                                                        {/*        '&:hover': {             // 선택적: hover 효과*/}
                                                        {/*            backgroundColor: 'rgba(0, 0, 0, 0.04)'*/}
                                                        {/*        }*/}
                                                        {/*    }}*/}
                                                        {/*>*/}
                                                        {/*    <ArrowForwardIosOutlinedIcon />*/}
                                                        {/*</IconButton>*/}
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            </Box>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </List>
                        )}
                    </Droppable>
                </DragDropContext>
            </Box>
        </Container>
    );
}
export default validationAuth(RegisteredList);